var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrandSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1674_1463478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.77393 13.8906V17.0917C6.77393 17.5075 7.03118 17.8799 7.42003 18.027L15.42 21.054C15.6481 21.1403 15.8998 21.1403 16.1278 21.054L24.1278 18.027C24.5167 17.8799 24.7739 17.5075 24.7739 17.0917V13.8906",
    stroke: "#292D32",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2739 15L15.42 16.5688C15.6481 16.6551 15.8998 16.6551 16.1278 16.5688L20.2739 15",
    stroke: "#292D32",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.77393 15.3516C6.77393 15.3516 6.77393 14.7049 6.77393 14.0964C6.77393 13.6806 7.03118 13.3083 7.42003 13.1611L15.42 10.1341C15.6481 10.0478 15.8998 10.0478 16.1278 10.1341L24.1278 13.1611C24.5167 13.3083 24.7739 13.6807 24.7739 14.0964L24.7739 14.8651",
    stroke: "#292D32",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1674_1463478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(0.412109)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandSettingsIcon);
export default __webpack_public_path__ + "static/media/BrandSettingsIcon.7d4bb968aef2c589752c386fa40b5c60.svg";
export { ForwardRef as ReactComponent };